import { notifyError } from 'shared'

export async function copyTextToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text)
  } catch(error) {
    notifyError(error, { message: 'Failed to copy text to clipboard' });
  }
}
